module.exports = __webpack_public_path__ + "static/media/fa-heart-o.abeca945.svg";